// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"50b792b3","854":"6e5f98a9","933":"5e8c9baa"}[chunkId] + ".chunk.css";
};